import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { TranslateModule } from '@ngx-translate/core';
import {
  atLeastOneLowercaseRegex,
  atLeast9CharactersRegex,
  atLeastOneNumericRegex,
  atLeastOneSpecialCharacterRegex,
  atLeastOneUppercaseRegex,
} from '@irian-ro/constants';
@Component({
  selector: 'auth-password-rules',
  standalone: true,
  imports: [CommonModule, DividerModule, TranslateModule],
  templateUrl: './password-rules.component.html',
  styleUrl: './password-rules.component.scss',
})
export class PasswordRulesComponent {
  @Input() password: string | undefined = undefined;

  protected readonly atLeastOneLowercase = atLeastOneLowercaseRegex;
  protected readonly atLeastOneUppercase = atLeastOneUppercaseRegex;
  protected readonly atLeastOneNumeric = atLeastOneNumericRegex;
  protected readonly atLeastOneSpecialCharacter = atLeastOneSpecialCharacterRegex;
  protected readonly atLeast9Characters = atLeast9CharactersRegex;

  isAccomplished(regex: RegExp, password: string) {
    if (!password || password.length === 0) {
      return false;
    }
    return regex.test(password);
  }
}
